import React from 'react'
import SnartInput from '../../../components/smartInputs/group'
import SectionDivider from './sectionDivider'
import { FotterWidthButtons, SectionHeader } from './main'
import { Box, Grid, ThemeProvider, useMediaQuery, Checkbox } from '@material-ui/core'
import useObjectState from '../../../hooks/useObjectState'
import { func, object } from 'prop-types'
import styled from 'styled-components'
import { frontTheme } from '../../components/layout_user/index'
import { requires, validateEmail } from '../../../helpers/validateform'
import { Alert } from '@material-ui/lab'
import DataDeposito from './dataDeposito'
import handleScrollItonView from './handleScrollIntoView'
import { cfdiCollection, methodPayAppointment, conceptbill } from '../../../constants'

const Text = styled.div`
  font-family: 'imlregular';
  color: var(--first);
  margin-bottom: .2em;
  span {
    color: var(--second);
    margin-right: .5em;
  }
`

const SmarInputsStyled = styled(SnartInput)`
  fieldset {
    border-color: rgb(0 178 173);
  }
`

const TextBold = styled(Text)`
  font-family: 'imlbold'; font-weight: bold;
  font-size: 1.1em;
`

const Divider = styled.div`
  border-bottom: 1px solid var(--first);
  margin: 1em 0px;
`

const newTheme = {
  ...frontTheme,
  overrides: {
    MuiInput: {
      underline: {
        '&:after': {
          borderBottom: '2px solid #00b2ad'
        },
        '&$focused:after': {
          borderBottomColor: '#00b2ad'
        },
        '&:before': {
          borderBottom: '1px solid #00b2ad'
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: '2px solid #00b2ad'
        },
        '&$disabled:before': {
          borderBottom: '1px dotted #00b2ad'
        }
      }
    }
  }
}

const GenerealInfo = props => {
  const [state, setState] = useObjectState(props.initialState || {})
  const isMobile = useMediaQuery('(max-width:690px)')

  const inputProps = {
    inputProps: { style: { fontSize: '1em' } },
    InputLabelProps: { style: { fontSize: '.9em' } }
  }

  const handleCheckBoxChange = (event) => {
    setState({ [event.target.name]: event.target.checked })
  }

  const handleNext = () => {
    var inputsRequires = ['name', 'plastname', 'mlastname', 'birtdate', 'email', 'phone', 'methodPay', 'willBill']
    if (state.willBill === 'yes') inputsRequires = [...inputsRequires, 'cfdi', 'billRfc', 'billSocial', 'billPostalCode', 'conceptbill', 'billEmail']
    const errors = requires(state, inputsRequires)
    if (errors) {
      handleScrollItonView()
      return setState({ errors: errors, errorMessage: 'Los campos marcados con rojo son obligatorios' })
    }
    if (state.phone.toString().length < 10) {
      handleScrollItonView()
      return setState({ errors: ['phone'], errorMessage: 'El Teléfono no es válido' })
    }
    if (!validateEmail(state.email)) {
      handleScrollItonView()
      return setState({ errors: ['email'], errorMessage: 'el correo electrónico no es válido' })
    }
    if (state.willBill === 'yes') {
      if (state.billPostalCode.toString().length < 5) {
        handleScrollItonView()
        return setState({ errors: ['billPostalCode'], errorMessage: 'Código postal no válido' })
      }
    }
    if (!state.realeaseByWeb && !state.realeaseByFacebook && !state.realeaseByRefer && !state.realeaseCompany && !state.releaseByOtherText) {
      handleScrollItonView()
      return setState({ errorMessage: 'Por favor indicanos cómo se enteró de nosotros' })
    }
    if (!state.studyReasonSintomas && !state.studyReasonCirugia && !state.studyReasonContactWidtPeople && !state.studyReasonProfecional && !state.studyReasonViaje && !state.studyReasonOtherText) {
      handleScrollItonView()
      return setState({ errorMessage: 'Por favor indicanos el motivo por el qué se realiza el estudio' })
    }

    const secureData = { ...state }
    delete secureData.errors
    delete secureData.errorMessage
    delete secureData.date
    delete secureData.stringDate
    delete secureData._id
    props.onConfirm(secureData)
  }

  return (
    <ThemeProvider theme={newTheme}>
      <SectionDivider step={2}>
        <SectionHeader
          title='Captura tus datos'
          // subtitle='Todos los campos son obligatorios'
        />
        <Box mt={4}>
          <Box>
            {!!state.errorMessage && (
              <Box mb={5}>
                <Alert severity='error'>{state.errorMessage}</Alert>
              </Box>
            )}
          </Box>
          <Grid container spacing={isMobile ? 1 : 3}>
            <Grid item xs={6} md={4}>
              <SmarInputsStyled limit={50} {...inputProps} size='small' color='secondary' variant='standard' state={state} setState={setState} name='name' label='Nombre(s)' />
            </Grid>
            <Grid item xs={6} md={4}>
              <SmarInputsStyled limit={50} {...inputProps} size='small' color='secondary' variant='standard' state={state} setState={setState} name='plastname' label='Apellido paterno' />
            </Grid>
            <Grid item xs={6} md={4}>
              <SmarInputsStyled limit={50} {...inputProps} size='small' color='secondary' variant='standard' state={state} setState={setState} name='mlastname' label='Apellido materno' />
            </Grid>
            <Grid item xs={6} md={4}>
              <SmarInputsStyled limit={50} {...inputProps} size='small' color='secondary' variant='standard' state={state} setState={setState} name='birtdate' label='Fecha de nacimiento DD/MM/AAAA' />
            </Grid>
            <Grid item xs={6} md>
              <SmarInputsStyled limit={50} {...inputProps} size='small' color='secondary' variant='standard' state={state} setState={setState} name='email' label='Correo electrónico' />
            </Grid>
            <Grid item xs={6} md>
              <SmarInputsStyled limit={10} filter='number' {...inputProps} size='small' color='secondary' variant='standard' state={state} setState={setState} name='phone' label={isMobile ? 'Teléfono' : 'Teléfono (preferente con WhatsApp)'} />
            </Grid>
          </Grid>
          <Box mt={4} />
          <Grid container spacing={6}>
            <Grid item xs={12} md={6} style={{ overflow: 'hidden' }}>
              <SmarInputsStyled
                size='small'
                {...inputProps}
                state={state}
                setState={setState}
                type='select'
                options={methodPayAppointment}
                color='secondary'
                name='methodPay'
                label='Método de pago'
              />
              <DataDeposito />
            </Grid>
            <Grid item md={6} style={{ overflow: 'hidden' }}>
              <SmarInputsStyled
                size='small'
                {...inputProps}
                state={state}
                setState={setState}
                type='select'
                options={{ yes: 'Si', no: 'No' }}
                color='secondary'
                name='willBill'
                label='¿Requieres factura?'
              />
              <Box pt={2}>
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <SmarInputsStyled disabled={state.willBill !== 'yes'} limit={20} {...inputProps} size='small' color='secondary' variant='standard' state={state} setState={setState} name='billRfc' label='RFC' />
                  </Grid>
                  <Grid item xs={8}>
                    <SmarInputsStyled disabled={state.willBill !== 'yes'} limit={50} {...inputProps} size='small' color='secondary' variant='standard' state={state} setState={setState} name='billSocial' label='Razón social' />
                  </Grid>
                </Grid>

                <Grid container spacing={1}>
                  <Grid item xs={3}>
                    <SmarInputsStyled disabled={state.willBill !== 'yes'} limit={5} filter='number' {...inputProps} size='small' color='secondary' variant='standard' state={state} setState={setState} name='billPostalCode' label='C.P.' />
                  </Grid>
                  <Grid item xs={9}>
                    <SmarInputsStyled disabled={state.willBill !== 'yes'} limit={50} {...inputProps} size='small' color='secondary' variant='standard' state={state} setState={setState} name='billEmail' label='Correo' />
                  </Grid>
                </Grid>
                <Box mt={2}>
                  <Text>
                    Concepto de facturación: <br />
                    <Box mt={1} style={{ overflow: 'hidden' }}>
                      <SmarInputsStyled
                        disabled={state.willBill !== 'yes'}
                        size='small'
                        {...inputProps}
                        state={state}
                        setState={setState}
                        type='select'
                        options={conceptbill}
                        color='secondary'
                        name='conceptbill'
                        label='Seleccionar'
                      />
                    </Box>

                  </Text>
                </Box>
                <Box mt={1}>
                  <Text>
                    Uso de CFDI: <br />
                    <Box mt={1} style={{ overflow: 'hidden' }}>
                      <SmarInputsStyled
                        disabled={state.willBill !== 'yes'}
                        size='small'
                        {...inputProps}
                        state={state}
                        setState={setState}
                        type='select'
                        options={cfdiCollection}
                        color='secondary'
                        name='cfdi'
                        label='Seleccionar'
                      />
                    </Box>

                  </Text>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Divider />
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextBold>¿Cómo se enteró de nosotros?</TextBold>
              <Grid container>
                <Grid item container wrap='nowrap' alignItems='center' xs={4} md={6}>
                  <Checkbox color='secondary' checked={state.realeaseByWeb} onChange={handleCheckBoxChange} name='realeaseByWeb' />
                  <Text>Página web</Text>
                </Grid>
                <Grid item container wrap='nowrap' alignItems='center' xs={4} md={6}>
                  <Checkbox color='secondary' checked={state.realeaseByFacebook} onChange={handleCheckBoxChange} name='realeaseByFacebook' />
                  <Text>Facebook</Text>
                </Grid>
                <Grid item container wrap='nowrap' alignItems='center' xs={4} md={6}>
                  <Checkbox color='secondary' checked={state.realeaseByRefer} onChange={handleCheckBoxChange} name='realeaseByRefer' />
                  <Text>Recomendación</Text>
                </Grid>
                <Grid item container wrap='nowrap' alignItems='center' xs={4} md={6}>
                  <Checkbox color='secondary' checked={state.realeaseCompany} onChange={handleCheckBoxChange} name='realeaseCompany' />
                  <Text>Empresa</Text>
                </Grid>
                <Grid item xs={3} container wrap='nowrap' alignItems='center'>
                  <Checkbox color='secondary' checked={state.realeaseOther} onChange={handleCheckBoxChange} name='realeaseOther' />
                  <Text>Otro</Text>
                </Grid>
                <Grid item xs>
                  <SmarInputsStyled disabled={!state.realeaseOther} {...inputProps} size='small' color='secondary' variant='standard' state={state} setState={setState} name='releaseByOtherText' />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextBold>Motivo por el qué se realiza el estudio</TextBold>
              <Grid container>
                <Grid item container wrap='nowrap' alignItems='center' xs={6}>
                  <Checkbox color='secondary' checked={state.studyReasonSintomas} onChange={handleCheckBoxChange} name='studyReasonSintomas' />
                  <Text>Presenta síntomas</Text>
                </Grid>
                <Grid item container wrap='nowrap' alignItems='center' xs={6}>
                  <Checkbox color='secondary' checked={state.studyReasonCirugia} onChange={handleCheckBoxChange} name='studyReasonCirugia' />
                  <Text>Cirugía</Text>
                </Grid>
                <Grid item xs={6} container wrap='nowrap' alignItems='center'>
                  <Checkbox color='secondary' checked={state.studyReasonContactWidtPeople} onChange={handleCheckBoxChange} name='studyReasonContactWidtPeople' />
                  <Text>Contacto con persona COVID-19 detectado (positivo)
                  </Text>
                </Grid>
                <Grid item container wrap='nowrap' alignItems='center' xs={6}>
                  <Checkbox color='secondary' checked={state.studyReasonProfecional} onChange={handleCheckBoxChange} name='studyReasonProfecional' />
                  <Text>
                    Profesional de la salud
                  </Text>
                </Grid>
                <Grid item xs={3} container wrap='nowrap' alignItems='center'>
                  <Checkbox color='secondary' checked={state.studyReasonViaje} onChange={handleCheckBoxChange} name='studyReasonViaje' />
                  <Text>Viaje</Text>
                </Grid>
                <Grid item xs={3} container wrap='nowrap' alignItems='center'>
                  <Checkbox color='secondary' checked={state.studyReasonOther} onChange={handleCheckBoxChange} name='studyReasonOther' />
                  <Text>Otro</Text>
                </Grid>
                <Grid item xs>
                  <SmarInputsStyled disabled={!state.studyReasonOther} {...inputProps} size='small' color='secondary' variant='standard' state={state} setState={setState} name='studyReasonOtherText' />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <FotterWidthButtons
            onConfirm={handleNext}
            onBack={props.onBack}
          />
        </Box>
      </SectionDivider>
    </ThemeProvider>
  )
}

GenerealInfo.propTypes = {
  initialState: object,
  onBack: func,
  onConfirm: func
}

export default GenerealInfo
